import {
  Modal,
  ModalBody,
  ModalInput,
  ModalInputWrapper,
  ModalInputRadio,
  modalConnect,
  ModalFooter,
  ModalButton,
} from "@modal";

import {
  ceModalUpdateState,
} from "@js/actions/studio/modals.js";

import {
  ceDismissSaveCustomRowModal,
  ceSubmitSaveCustomRowModal,
  ceModalManageCustomRowsDismiss,
  ceRenameCustomRow,
  ceRenameCustomRowSave,
  ceRenameCustomRowCancel,
  ceDeleteCustomRow,
  ceDeleteCustomRowConfirm,
  ceDeleteCustomRowCancel,
} from "@js/actions/studio/campaign_content_section/custom_rows.js";

import clickWrap from "@js/helpers/click_wrap.js";
import classNames from "@js/helpers/class_names.js";

import LoadingSpinner from "@js/components/studio/utilities/loading_spinner.jsx";

const trClasses = (props, row) => {
  return classNames({
    "danger": props.delete_row_id == row.id,
  });
};

const renderRow = (props, row) => {
  let name;
  let actions = [];
  let trClasses = {};

  if ( props.delete_row_id == row.id ) {
    trClasses.danger = true;

    name = <div>
      <div>{
        props.error_message
        ? props.error_message
        : t("phrases.confirm_delete_custom_row")
      }</div>
      <strong>{ row.name }</strong>
    </div>;

    if ( props.delete_in_progress ) {
      actions.push(
        <LoadingSpinner width="18px" height="18px" />
      );
    } else {
      actions.push(<a
        onClick={clickWrap(() => props.dispatch(ceDeleteCustomRowCancel()))}
        href="#"
        className="button small-button diminished-button"
        key="cancel"
      >{ t("buttons.cancel") }</a>);

      actions.push(<a
        onClick={clickWrap(() => props.dispatch(ceDeleteCustomRowConfirm(row.id)))}
        href="#"
        className="button small-button dangerous-button"
        key="confirm"
      >{ t("buttons.delete") }</a>);
    }
  } else if ( props.rename_row_id == row.id ) {
    trClasses.danger = !!props.error_message;

    name = <div className="rename-custom-row">
      <ModalInput
        type="text"
        onChange={(e) =>
          props.dispatch(ceModalUpdateState({ rename_row_name: e.target.value }))
        }
        onEnter={clickWrap(() => props.dispatch(ceRenameCustomRowSave(row.id, props.rename_row_name)))}
        value={props.rename_row_name}
        autoFocus
        error={props.error_message}
      />
    </div>;

    if ( props.rename_in_progress ) {
      actions.push(
        <LoadingSpinner width="18px" height="18px" />
      );
    } else {
      actions.push(<a
        onClick={clickWrap(() => props.dispatch(ceRenameCustomRowCancel()))}
        href="#"
        className="button small-button diminished-button"
        key="cancel"
      >{ t("buttons.cancel") }</a>);

      actions.push(<a
        onClick={clickWrap(() => props.dispatch(ceRenameCustomRowSave(row.id, props.rename_row_name)))}
        href="#"
        className="button small-button btn-primary"
        key="save"
      >{ t("buttons.save") }</a>);
    }
  } else {
    name = row.name;

    actions.push(<a
      onClick={clickWrap(() => props.dispatch(ceRenameCustomRow(row.id, row.name)))}
      href="#"
      className="button small-button diminished-button"
      key="rename"
    >{ t("buttons.rename") }</a>);

    actions.push(<a
      onClick={clickWrap(() => props.dispatch(ceDeleteCustomRow(row.id)))}
      href="#"
      className="button small-button diminished-button"
      key="delete"
    >{ t("buttons.delete") }</a>);
  }

  return (
    <tr key={ row.id } className={ classNames(trClasses) }>
      <td width="65%">{ name }</td>
      <td className="actions">{ actions }</td>
    </tr>
  );
};

export default modalConnect((props) => {
  return (
    <Modal
      title={t("phrases.manage_custom_rows")}
      onCancel={() => props.dispatch(ceModalManageCustomRowsDismiss())}
      cancelText={t("buttons.close")}
    >
      {
        props.custom_rows ? (
          ( props.custom_rows.length ) > 0 ? (
            <table className="data-table">
              <tbody>
                {
                  props.custom_rows.map((row) => renderRow(props, row))
                }
              </tbody>
            </table>
          ) : (
            <div>
              { t("empty_table.manage_custom_rows") }
            </div>
          )
        ) : (
          <div>{ t("phrases.react_content.loading_custom_rows") }</div>
        )
      }
    </Modal>
  );
});
